<template>
    <div class="edit-contact-form-container page-content">
        <!--    Contacts    -->
        <div class="tab-header-container">
            <h2 class="form-label">{{getTitle}}</h2>
            <LiteButton @click.native="close"
                        style="font-size: 35px; float: right;"
                        class="edit-button"
                        :hoverColor="'red'"
                        :icon="'far fa-window-close'">
            </LiteButton>
        </div>

        <hr class="form-line">

        <form class="inputs-modal-container" onsubmit="saveForm">
            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'firstName'"
                       :name="'firstName'"
                       :initialValue="getAttribute('firstName')"
                       :label="'Име'"
                       :placeholder="'Въведете име'">
            </InputText>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'middleName'"
                       :name="'middleName'"
                       :initialValue="getAttribute('middleName')"
                       :label="'Презиме'"
                       :placeholder="'Въведете презиме'">
            </InputText>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'lastName'"
                       :name="'lastName'"
                       :initialValue="getAttribute('lastName')"
                       :label="'Фамилия'"
                       :placeholder="'Въведете фамилия'">
            </InputText>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'relationDescription'"
                       :name="'relationDescription'"
                       :initialValue="getAttribute('relationDescription')"
                       :label="'Връзка'"
                       :placeholder="'Въведете тип връзка'">
            </InputText>

            <div class="input">
                <label class="contact-birth-date">Дата на раждане</label>
                <date-picker v-model="birthDate"
                             type="date"
                             class="date-input"
                             :format="'DD-MM-YYYY'"
                             :lang="{formatLocale: getFormatLocale()}"
                             placeholder="Изберете дата"/>
            </div>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'email'"
                       :name="'email'"
                       :initialValue="getAttribute('email')"
                       :label="'Е-Мейл'"
                       :placeholder="'Въведете Е-Мейл'">
            </InputText>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'phoneNumber'"
                       :name="'phoneNumber'"
                       :initialValue="getAttribute('phoneNumber')"
                       :label="'Телефон'"
                       :placeholder="'Въведете телефон'">
            </InputText>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'address'"
                       :name="'address'"
                       :initialValue="getAttribute('address')"
                       :label="'Адрес'"
                       :placeholder="'Въведете адрес'">
            </InputText>

            <Checkbox class="input"
                      @value-change="setSupport"
                      :id="'support'"
                      :label="'Издръжка'"
                      :initialValue="getAttribute('support')"/>

            <Button class="save-button"
                    style="margin-top: 0"
                    @click.native="saveForm"
                    :color="'green'"
                    :text="'Запази'"
                    :icon="'fa fa-save'"></Button>

            <Button class="save-button"
                    style="margin-top: 60px;"
                    v-if="currentContact.id"
                    @click.native="showDeleteConfirm = true"
                    :color="'red'"
                    :text="'Изтрий'"
                    :icon="'fa fa-trash-alt'"></Button>

            <div id="confirmDeleteContact" class="delete-contact-confirm" v-if="showDeleteConfirm">
                <p>Сигурне ли сте?</p>
                <Button class="delete-contact-button-confirm" @click.native="deleteContact" :id="'yes'"
                        :text="'Да'"></Button>
                <Button class="delete-contact-button-confirm" @click.native="showDeleteConfirm = false" :id="'no'"
                        :text="'Не'"></Button>
            </div>
        </form>
    </div>
</template>

<script>
    import InputText from "@/shared/components/form/InputText";
    import Button from "@/shared/components/button/Button";
    import LiteButton from "@/shared/components/button/LiteButton";
    import workerService from "@/services/worker.service";
    import {cloneDeep} from 'lodash';
    import DatePicker from 'vue2-datepicker';
    import Checkbox from "@/shared/components/form/Checkbox";
    import dateService from "@/services/date.service";

    export default {
        name: "WorkerContactEditForm",
        components: {Checkbox, LiteButton, InputText, Button, DatePicker},
        props: {
            contact: Object
        },
        data() {
            return {
                currentContact: cloneDeep(this.contact),
                birthDate: null,
                showDeleteConfirm: false
            }
        },
        methods: {
            setAttribute(value) {
                this.currentContact[value.name] = value.currentValue;
            },
            setSupport(value) {
                this.currentContact.support = value.isChecked;
            },
            getAttribute(name) {
                return this.currentContact.id ? this.currentContact[name] : null;
            },
            saveForm() {
                workerService.addOrEditContact(this.currentContact)
                    .then(({data}) => {
                        this.$store.commit('setContacts', data);
                        this.$emit('close-clicked', {});
                    })
                    .catch(() => this.$emit('close-clicked', {}));
            },
            deleteContact() {
                workerService.deleteContact(this.currentContact.id)
                    .then(({data}) => {
                        this.$store.commit('setContacts', data);
                        this.$emit('close-clicked', {});
                    })
                    .catch(() => this.$emit('close-clicked', {}));
            },
            close() {
                this.$emit('close-clicked', {});
            },
            getFormatLocale() {
                return dateService.getFormatLocale();
            }
        },
        computed: {
            getTitle() {
                return this.currentContact.id ? 'Редактиране на контакт' : 'Добавяне на контакт';
            }
        },
        watch: {
            birthDate: {
                handler(newVal) {
                    if (newVal) {
                        this.currentContact.birthDate = dateService.formatDateISO(newVal);
                    } else {
                        this.currentContact.birthDate = null;
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .edit-contact-form-container {
        width: 750px;
        height: auto;
        margin: 50px auto;
        padding: 20px;
        z-index: 120;
        background-color: #ffffff;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        overflow: auto;
    }

    .inputs-modal-container {
        position: absolute;
        top: 100px;
        bottom: 0;
        left: 125px;
        width: 500px;
    }

    .contact-birth-date {
        float: left;
        height: 30px;
        font-size: 20px;
        color: var(--dark-grey);
    }

    .date-input {
        display: inline-block;
        width: 500px;
    }

    .input {
        display: block;
        width: 500px;
        height: 95px;
        margin: 20px auto 0 auto;
    }

    .save-button {
        width: 300px;
        height: 60px;
        font-size: 26px;
        margin: 45px;
    }

    .delete-contact-confirm p {
        text-align: center;
    }

    .delete-contact-button-confirm {
        width: 80px;
        height: 40px;
        float: left;
        margin: 10px;
        font-size: 20px;
    }

    .delete-contact-confirm {
        margin: auto;
        height: 80px;
        width: 200px;
        z-index: 20;
        -webkit-box-shadow: 0 0px 5px 1px var(--shadow-color);
        -moz-box-shadow: 0 0px 5px 1px var(--shadow-color);
        box-shadow: 0 0px 5px 1px var(--shadow-color);
        background-color: #ffffff;
        padding: 15px;
        font-size: 24px;
        color: var(--grey);
    }
</style>